import Error from '../model/Error';
import axios from 'axios';

export default class PhysicalAccessConditionRepository {
    static findAll() {
        return new Promise((resolve, reject) => {
            axios
                .get('/club/physical-access-conditions')
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
